import API_END_POINTS from "../../utilities/Constants/ApiEndpoints";
import { baseApi } from "./baseQuery";

const authPageApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (values) => ({
        url: API_END_POINTS.LOGIN,
        method: "POST",
        body:values
      }),
    }),

    verifyMagicLick: build.query({
      query: (token) => ({
        url: `${API_END_POINTS.VERIFY_MAGIC_LINK}/?signed_link=${token}`,
        method: "GET"
      }),
    }),

  }),
   // @ts-ignore
	overrideExisting: module.hot?.status() === "apply",
});

export const { 
  useLoginMutation,
  useLazyVerifyMagicLickQuery
} = authPageApi;
